import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container after-sale-list" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "img-list"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "action-list" }
const _hoisted_7 = {
  key: 0,
  class: "refund-detail"
}
const _hoisted_8 = {
  key: 0,
  class: "voucher-imgs"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "partial-refund-content" }

import Pagination from '@/components/Pagination.vue'
import { useRoute, useRouter } from 'vue-router'
import { reactive, onMounted, ref, computed } from 'vue'
import { getAfterSaleListApi, handleAfterSaleApi, uploadAfterSaleVoucherApi, getAfterSaleUserInfoApi, refundRejectApi } from '@/apis/order'
import { ElMessage, } from 'element-plus'
import { OrderStatus } from '@/enums/order'
import { openRouteInNewWindow } from '@/utils/router-helper'
import ImageUploaderDialog from '@/components/upload/Index.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// 映射关系
const orderTypeMap = { 1: '蛋糕', 5: '零食', 8: '鲜花' }
const serviceStatus = { 1: '未处理', 2: '同意', 3: '驳回', 4: '用户取消' }
const refundStatus = { 0: '待审核', 1: '同意', 2: '驳回', 3: '取消退款', 4: '退款完成' }
const reasonTypeArr = ['', '不想要了', '买错了', '协商一致退款', '商品质量问题', '其他原因']

const activeIndex = ref(Number(route.query.type) || 1)
const loading = ref(false)
const filters = reactive({
    order_no: '',
    status: activeIndex.value == 1 ? '1' : '0',
    page: 1,
    page_size: 10,
})

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    loading.value = true
    const { code, data, msg } = await getAfterSaleListApi({
        ...filters,
        type: activeIndex.value
    }) as any
    loading.value = false
    if (code != 200) return ElMessage.error(msg || '获取数据失败')
    tableData.value = data.data
    total.value = data.total
}

const statusMap = computed(() => {
    return activeIndex.value == 1 ? serviceStatus : refundStatus
})

const onTabChange = (val) => {
    activeIndex.value = val
    filters.order_no = ''
    filters.status = val == '1' ? '1' : '0'
    filters.page = 1
    getList()
}

const search = () => {
    filters.page = 1
    getList()
}

const onPageChange = (val) => {
    filters.page = val
    getList()
}

const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

// 详情与处理逻辑
const dialogVisible = ref(false)
/**
 * 弹窗打开方式：
 *      view：查看 
 *      process：首次处理-展示用户填写的申请信息；首次处理-填写处理结果 
 *      edit：修改（当查看时，先隐藏弹框底部操作按钮；然后将 type 值设置为 1， 因为之后的操作逻辑与 1 完相同（尤其是 $('#modal-content-'+type).show() 根据type进行了展示逻辑判断））
 *      reject: 驳回
 * */
const dialogType = ref('view')
const dialogTitle = ref('详情')
const currentRefund = ref<any>(null)
const processForm = reactive({
    kefu_describe: '',
    delivery_address: ''
})

const getReasonText = (refund: any) => {
    return refund.refund_reason == 5 
        ? '其他原因：' + refund.refund_reason_other 
        : reasonTypeArr[refund.refund_reason] || '无'
}

const onView = async (row: any, type: number) => {
    // type：1 订单号  type：2 查看操作
    if (type == 1  || type == 2 && activeIndex.value == 1) {
        openRouteInNewWindow({
            path: '/order/show',
            query: { id: row.order_id }
        })
    } else {
        openDialog(row.id, 'view')
    }
}

const closeDialog = () => {
    dialogVisible.value = false
    processForm.kefu_describe = ''
    processForm.delivery_address = ''
}

const openDialog = async (id, type) => {
    dialogType.value = type
    dialogTitle.value = '售后详情'
    try {
        const res = await getAfterSaleUserInfoApi(id) as any
        if (res.code == 200) {
            currentRefund.value = res.data
            dialogVisible.value = true
        } else {
            ElMessage.error(res.msg)
        }
    } catch (err) {
        ElMessage.error('获取详情失败')
    }
}

const processDisabled = (row: any) => {
    const { item_name, status } = row
    if (item_name) {
        return status != 1
    } else {
        return status != 0
    }
}

const submitProcess = async (type: number) => {
    if (type == 2 && !processForm.kefu_describe) {
        return ElMessage.warning('请填写驳回理由')
    }
    if (type == 1 && activeIndex.value == 2 && !processForm.delivery_address) {
        return ElMessage.warning('请填写退货地址')
    }

    const id = activeIndex.value == 1 ? currentRefund.value.id : currentRefund.value.id
    const { code, data, msg } = await handleAfterSaleApi({
        id: id,
        order_no: currentRefund.value.order_no,
        type: type,
        kefu_describe: processForm.kefu_describe,
        delivery_address: processForm.delivery_address
    }) as any
    if (code == 200) {
        ElMessage.success('操作成功')
        closeDialog()
        getList()
    } else {
        ElMessage.error(msg)
    }
}

// 仅退款驳回
const rejectDialogVisible = ref(false)
const rejectForm = reactive({
    id: '',
    description: ''
})
const rejectCancel = () => {
    rejectDialogVisible.value = false
    rejectForm.id = ''
    rejectForm.description = ''
}
const onRejectSubmit = async () => {
    if (!rejectForm.description) return ElMessage.warning('请填写驳回理由')
    const { code, data, msg } = await refundRejectApi(rejectForm.id, rejectForm.description) as any
    if (code == 200) {
        ElMessage.success('操作成功')
        rejectCancel()
        getList()
    } else {
        ElMessage.error(msg)
    }
}

const toOrderEdit = (order_id, item_id = '') => {
    let query:any = {}
    query.id = order_id
    if (item_id) {
        query.item_id = item_id
    }
    openRouteInNewWindow({
        path: '/order/edit',
        query
    })
}

// 部分退款逻辑
const partialRefundVisible = ref(false)
const useOtherRefund = ref(false)
const fileList = ref<any[]>([])
const partialRefundForm = reactive({
    id: '',
    refund_price: '',
    payment_voucher: []
})

const canPartialRefund = (row: any) => {
    // 仅退款：if_bufen == 1 且 (status == 1 或 (status == 2 且 refund_status != 4))
    // 退货退款：if_bufen == 0 且 express_no 且 status == 1 (这部分逻辑在 PHP 中被注释了或较复杂)
    // 根据 PHP 逻辑：
    if (activeIndex.value == 1) {
        return row.if_bufen == 1 && (row.status == 1 || (row.status == 2 && row.refund_status != 4))
    } else {
        // 退货退款中的部分退款按钮在 PHP 中被注释了，但逻辑类似
        return row.if_bufen == 0 && row.express_no && row.status == 1
    }
}

const onPartialRefund = (row: any) => {
    if (activeIndex.value == 1) {
        router.push(`/order/edit?id=${row.order_id}&item_id=${row.item_id}`)
    } else {
        currentRefund.value = row
        partialRefundForm.id = activeIndex.value == 1 ? row.refund_id : row.id
        partialRefundForm.refund_price = ''
        partialRefundForm.payment_voucher = []
        fileList.value = []
        useOtherRefund.value = false
        partialRefundVisible.value = true
    }
}

const toAddMoney = () => {
    const row = currentRefund.value
    const userId = row.buyer_id || row.user_id
    openRouteInNewWindow({
        path: ''
    })
    window.open(`/admin/user_money/add?user_id=${userId}&order_no=${row.order_no}`, '_blank')
}

const submitOfflineRefund = async () => {
    if (!partialRefundForm.refund_price) return ElMessage.warning('请填写退款金额')
    if (!partialRefundForm.payment_voucher) return ElMessage.warning('请上传凭证')

    const { code, data, msg } = await uploadAfterSaleVoucherApi({
        id: partialRefundForm.id,
        payment_voucher: partialRefundForm.payment_voucher.join(','),
        refund_price: partialRefundForm.refund_price
    }) as any
    if (code != 200) return ElMessage.error(msg)
    ElMessage.success('退款完成')
    partialRefundVisible.value = false
    getList()
}

onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_decimal = _resolveDirective("decimal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "处理状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusMap.value, (label, value) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: value,
              label: label,
              value: value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeIndex.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeIndex).value = $event)),
      onTabChange: onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "仅退款",
          name: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "退货退款",
          name: 2
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      class: "mt20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号",
          width: "130"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: "product-link",
              onClick: _withModifiers(($event: any) => (onView(row, 1)), ["stop"])
            }, _toDisplayString(row.order_no), 9, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: activeIndex.value == 1 ? 'buyer_id' : 'username',
          label: "用户"
        }, null, 8, ["prop"]),
        _createVNode(_component_el_table_column, { label: "商品信息" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.item_name || '整单退款'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "提交时间",
          width: "145"
        }),
        (activeIndex.value == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_table_column, { label: "订单状态" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(OrderStatus)[row.status] || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "channel_no",
                label: "用户渠道"
              }),
              _createVNode(_component_el_table_column, {
                prop: "reason",
                label: "退款原因"
              }),
              _createVNode(_component_el_table_column, { label: "图片" }, {
                default: _withCtx(({ row }) => [
                  (row.images && row.images.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.images, (img, index) => {
                          return (_openBlock(), _createBlock(_component_el_image, {
                            key: index,
                            src: img.l_path,
                            "preview-src-list": row.images.map(i => i.l_path),
                            class: "table-img"
                          }, null, 8, ["src", "preview-src-list"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "--"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "refund_msg",
                label: "用户补充描述"
              }),
              _createVNode(_component_el_table_column, {
                prop: "admin_reason",
                label: "驳回理由"
              }),
              _createVNode(_component_el_table_column, {
                label: "处理状态",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(activeIndex.value == 1 ? serviceStatus[row.status] : refundStatus[row.status]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "operate_time",
                label: "客服操作时间",
                width: "145"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_table_column, { label: "类型" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(orderTypeMap[row.order_type] || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "wuliu",
                label: "物流状态"
              }),
              _createVNode(_component_el_table_column, {
                prop: "channel_no",
                label: "订单来源"
              }),
              _createVNode(_component_el_table_column, {
                prop: "refund_msg",
                label: "用户补充描述"
              }),
              _createVNode(_component_el_table_column, {
                prop: "kefu_describe",
                label: "说明理由"
              }),
              _createVNode(_component_el_table_column, { label: "处理状态" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(refundStatus[row.status]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "express_no",
                label: "寄回运单号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "user_wuliu",
                label: "寄回运单号物流状态"
              })
            ], 64)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (onView(row,2))
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (activeIndex.value == 1 && row.if_bufen == 1 || activeIndex.value == 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (row.item_name)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          disabled: row.status != 1,
                          title: row.status != 1 ? '当前订单不是同意状态' : '',
                          onClick: ($event: any) => (toOrderEdit(row.order_id, row.item_id))
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode(" 处理 ")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "title", "onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          disabled: processDisabled(row),
                          title: processDisabled(row) ? '仅待审核状态订单可处理' : '',
                          onClick: ($event: any) => (openDialog(row.id, 'process'))
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode(" 处理 ")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "title", "onClick"]))
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: (row.if_bufen == 1 || row.express_no) || row.status != 1,
                title: row.if_bufen == 1 ? '该订单为部分退款' : row.express_no ? '用户还未上传寄件物流号' : row.status != 1 ? '当前订单不是同意状态' : '',
                onClick: ($event: any) => (toOrderEdit(row.order_id))
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode(" 去退款 ")
                ])),
                _: 2
              }, 1032, ["disabled", "title", "onClick"]),
              (activeIndex.value == 2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    disabled: row.status != 1 || row.express_no,
                    title: row.status != 1 ? '当前订单不是同意状态' : (row.express_no ? '用户已上传物流单号' : ''),
                    onClick: ($event: any) => (openDialog(row.id, 'edit'))
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode(" 修改 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              (activeIndex.value == 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    disabled: row.if_bufen == 0 || row.status != 2 || row.status == 2 && row.refund_status == 4,
                    title: row.if_bufen == 0 ? '该订单为整单退款' : (row.status != 2 ? '当前订单不是同意状态' : (row.status == 2 && row.refund_status == 4 ? '该订单已处理' : '')),
                    onClick: ($event: any) => (onPartialRefund(row))
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode(" 部分退款 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              (activeIndex.value == 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    type: "primary",
                    size: "small",
                    disabled: row.status != 1,
                    title: row.status == 2 || row.status == 3 ? '当前订单已处理' : (row.status == 4 ? '用户取消退款' : ''),
                    onClick: ($event: any) => {rejectForm.id = row.order_id; rejectDialogVisible.value = true}
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode(" 驳回 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: rejectDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rejectDialogVisible).value = $event)),
      title: "驳回处理"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: rejectCancel
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onRejectSubmit
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("驳回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: rejectForm,
          "label-width": "125px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "驳回原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: rejectForm.description,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rejectForm.description) = $event)),
                  rows: 3,
                  placeholder: "请填写驳回原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogTitle.value
    }, {
      footer: _withCtx(() => [
        (dialogType.value == 'process')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_el_button, { onClick: closeDialog }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("取消")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (submitProcess(2)))
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("驳回")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (submitProcess(1)))
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createTextVNode("同意")
                ])),
                _: 1
              })
            ]))
          : (dialogType.value == 'edit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_el_button, { onClick: closeDialog }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("取消")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (submitProcess(1)))
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("保存修改")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (currentRefund.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_descriptions, {
                column: 1,
                border: "",
                "label-width": "125",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "订单号" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentRefund.value.order_no), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "退货件数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentRefund.value.refund_goods_num), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "申请退款金额" }, {
                    default: _withCtx(() => [
                      _createTextVNode("￥" + _toDisplayString(currentRefund.value.refund_price), 1)
                    ]),
                    _: 1
                  }),
                  (activeIndex.value == 2)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 0,
                        label: "寄件方式"
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode("自行寄回")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_descriptions_item, { label: "退款原因" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getReasonText(currentRefund.value)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "上传凭证" }, {
                    default: _withCtx(() => [
                      (currentRefund.value.refund_voucher && currentRefund.value.refund_voucher != 'null')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRefund.value.refund_voucher.split(','), (img, index) => {
                              return (_openBlock(), _createBlock(_component_el_image, {
                                key: index,
                                src: img,
                                "preview-src-list": currentRefund.value.refund_voucher.split(','),
                                class: "voucher-img"
                              }, null, 8, ["src", "preview-src-list"]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "无"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "补充描述" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentRefund.value.refund_msg || '无'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (['process', 'edit', 'reject'].includes(dialogType.value))
                ? (_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    model: processForm,
                    "label-width": "125px",
                    class: "mt20"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "说明理由/驳回原因" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: processForm.kefu_describe,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((processForm.kefu_describe) = $event)),
                            rows: 3,
                            placeholder: "【同意】时可填写说明理由，【驳回】时必须填写驳回原因"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (dialogType.value != 'reject')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "退货地址"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "textarea",
                                modelValue: processForm.delivery_address,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((processForm.delivery_address) = $event)),
                                rows: 3,
                                placeholder: "同意退款时必填"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: partialRefundVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((partialRefundVisible).value = $event)),
      title: "部分退款处理方式",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[15] || (_cache[15] = ($event: any) => (partialRefundVisible.value = false))
        }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !useOtherRefund.value,
          onClick: submitOfflineRefund
        }, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [
            _createTextVNode("确定")
          ])),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_form, { "label-width": "120px" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "方式一" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: toAddMoney
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("去补余额")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "方式二" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: useOtherRefund.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((useOtherRefund).value = $event))
                  }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createTextVNode("选择其他方式")
                    ])),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (useOtherRefund.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_form_item, { label: "*客服退款金额" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_input, {
                          modelValue: partialRefundForm.refund_price,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((partialRefundForm.refund_price) = $event)),
                          placeholder: "请输入金额"
                        }, null, 8, ["modelValue"]), [
                          [_directive_decimal]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "*上传依据" }, {
                      default: _withCtx(() => [
                        _createVNode(ImageUploaderDialog, {
                          modelValue: partialRefundForm.payment_voucher,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((partialRefundForm.payment_voucher) = $event)),
                          "max-count": 2,
                          accept: ".jpg,.jpeg,.png"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})